import React, { useContext, useEffect, useRef, useState } from 'react';
import TijoriLogo from '../../../assets/images/tijori-logo.png';
import { Nav, Navbar, Popover, Overlay } from 'react-bootstrap';
import FeatureIcons from '../feature_icons';
import SearchBar from './search_bar/search_bar.component';
import FeedbackForm from '../../presentational/common/feedback_form/feedback_form.component';
import LoginRequiredModal from '../../common/login_required_modal/login_required_modal.component';
import './header.component.css';
import AppContext from '../../context';

function Header() {
  const context = useContext(AppContext);
  const [fbModalVisible, setFbModalVisible] = useState(false);
  const [isLoginModalVisible, setIsLoginModalVisible] = useState(false);
  const [showPopover, setShowPopover] = useState(false);
  const [popoverTarget, setPopoverTarget] = useState(null);
  const popoverContainer = useRef(null);

  const [isSearchVisible, setIsSearchVisible] = useState(false);
  //tools popovers
  const [trackingToolsVisible, setTrackingToolsVisible] = useState(false);
  const [researchToolsVisible, setResearchToolsVisible] = useState(false);

  const plans = {
    free: 'Free Plan',
    premium: 'Premium Plan',
  };

  const handleProfileItemClick = () => {
    if (!context.user.is_authenticated) {
      setIsLoginModalVisible(true);
      return;
    }
  };

  const popover = (
    <Popover id="profile-popover">
      <div className="popover-scroll-body">
        {context.user.is_authenticated && (
          <>
            <Popover.Content className="profile-item d-flex user-info position-relative">
              {context.user.phone_number ? (
                <div>
                  <div className="username">{context.user.full_name}</div>
                  <div className="phone">{context.user.phone_number}</div>
                </div>
              ) : (
                <div className="username">{context.user.email}</div>
              )}
              <div className="plan">{plans[context.planDetails.name]}</div>
            </Popover.Content>
            <hr />
          </>
        )}
        <div
          className={`profile-tools ${
            context.areTabsFixed ? 'fixed-tabs' : ''
          }`}
        >
          <Popover.Content className="profile-item">
            <div className="sub-head">TRACKING TOOLS</div>
            <div className="d-flex flex-wrap">
              <a
                href={
                  context.user.is_authenticated ? '/in/timeline' : undefined
                }
                onClick={() => handleProfileItemClick()}
                className="link-icon"
              >
                <div class="menu-icon">
                  <FeatureIcons feature="timeline" />
                </div>
                <div>Timeline</div>
              </a>
              <a
                href={
                  context.user.is_authenticated
                    ? '/in/portfolio'
                    : '/in/portfolio/sample'
                }
                className="link-icon"
              >
                <div class="menu-icon">
                  <FeatureIcons feature="portfolio" />
                </div>
                <div>Portfolio</div>
              </a>
              <a
                href={context.user.is_authenticated && '/in/watchlist'}
                onClick={() => handleProfileItemClick()}
                className="link-icon"
              >
                <div class="menu-icon">
                  <FeatureIcons feature="watchlist" />
                </div>
                <div>Watchlist</div>
              </a>
              <a
                href={context.user.is_authenticated && '/in/alerts'}
                onClick={() => handleProfileItemClick()}
                className="link-icon mt-3"
              >
                <div class="menu-icon">
                  <FeatureIcons feature="alerts" />
                </div>
                <div>Alerts</div>
              </a>
            </div>
          </Popover.Content>
          <hr />
          <Popover.Content className="profile-item">
            <div className="sub-head">RESEARCH TOOLS</div>
            <div className="d-flex flex-wrap">
              <a href="/in/ideas-dashboard/" className="link-icon">
                <div class="menu-icon">
                  <FeatureIcons feature="ideas-dashboard" />
                </div>
                <div>Ideas Dashboard</div>
              </a>
              <a href="/?r=n" className="link-icon">
                <div class="menu-icon">
                  <FeatureIcons feature="company-sector-research" />
                </div>
                <div>Companies & Sectors</div>
              </a>
              <a href="/filter/popular-queries" className="link-icon">
                <div class="menu-icon">
                  <FeatureIcons feature="stock-screener" />
                </div>
                <div>Stock Screener</div>
              </a>
              <a href="/in/markets" className="link-icon mt-3">
                <div class="menu-icon">
                  <FeatureIcons feature="markets" />
                </div>
                <div>Market Monitor</div>
              </a>
              <a href="/in/raw-materials" className="link-icon mt-3">
                <div class="menu-icon">
                  <FeatureIcons feature="raw-materials" />
                </div>
                <div>Raw Materials</div>
              </a>
              <a href="/in/macro" className="link-icon mt-3">
                <div class="menu-icon">
                  <FeatureIcons feature="macro" />
                </div>
                <div>Macro Indicators</div>
              </a>
            </div>
          </Popover.Content>
          <hr />
        </div>
        <Popover.Content>
          {context.user.is_authenticated &&
            context.planDetails.name === 'free' && (
              <a href="/account/subscription" className="signin-btn upgrade">
                Upgrade now
              </a>
            )}
          <div className="account-item">
            <a href="/whats-new" className="d-block">
              What's New
            </a>
          </div>
          <div className="account-item">
            <a href="/features?referrer=home" className="d-block">
              Features
            </a>
          </div>
          <div
            className="account-item d-block"
            onClick={() => setFbModalVisible(true)}
          >
            Contact Us
          </div>
        </Popover.Content>
        <hr />
        <Popover.Content>
          {!context.user.is_authenticated ? (
            <>
              <div className="account-item">
                <a className="d-block" href="/account/signin">
                  Sign In
                </a>
              </div>
              <div className="account-item">
                <a className="d-block" href="/account/signup">
                  Create an account
                </a>
              </div>
            </>
          ) : (
            <>
              <div className="account-item">
                <a href="/account/management" className="d-block">
                  Manage Account
                </a>
              </div>
              <div className="account-item">
                <a href="/accounts/logout" className="d-block">
                  Logout
                </a>
              </div>
            </>
          )}
        </Popover.Content>
      </div>
    </Popover>
  );

  const getInitials = () => {
    const { first_name, last_name, full_name } = context.user;
    if (first_name && last_name) {
      return first_name.charAt(0) + last_name.charAt(0);
    } else if (full_name) {
      return full_name.slice(0, 2);
    } else {
      return 'A';
    }
  };

  const handlePopoverVisibility = (e) => {
    setShowPopover(!showPopover);
    setPopoverTarget(popoverContainer.current);
  };

  const onToolsClick = (toolType) => {
    if (toolType === 'tracking') {
      setTrackingToolsVisible(!trackingToolsVisible);
      setResearchToolsVisible(false);
      return;
    }
    if (toolType === 'research') {
      setResearchToolsVisible(!researchToolsVisible);
      setTrackingToolsVisible(false);
      return;
    }
  };

  useEffect(() => {
    document.body.addEventListener('click', (e) => {
      if (
        !Array.from(document.querySelectorAll('.tools')).some((elem) =>
          elem.contains(e.target),
        )
      ) {
        setTrackingToolsVisible(false);
        setResearchToolsVisible(false);
      }
    });
  }, []);

  return (
    <>
      <div className="sticky-top">
        <Navbar
          expand={true}
          className={`${
            !context.areTabsFixed ? 'bg-white br-bottom' : 'header-fixed'
          } ${
            context.user.is_authenticated
              ? context.planDetails.name === 'free'
                ? 'auth free'
                : 'auth'
              : ''
          }`}
        >
          <Navbar.Brand
            href={`${window.location.origin}/?r=n`}
            className={`position-relative ${
              context.areTabsFixed || isSearchVisible ? 'd-none' : ''
            }`}
          >
            <img src={TijoriLogo} width="85" alt="Tijori" />
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="nav-dropdown"
            className={`no-border ${context.areTabsFixed ? 'fixed' : ''}`}
          />
          <Navbar.Collapse id="nav-dropdown" className="large">
            <Nav className={`ml-auto large`}>
              <ul className={`nav ${context.areTabsFixed ? 'fixed-tabs' : ''}`}>
                <li
                  className={`d-none-430 position-relative tools ${
                    context.areTabsFixed || isSearchVisible ? 'd-none' : ''
                  }`}
                  onClick={() => onToolsClick('tracking')}
                >
                  <div>
                    Tracking<span className="d-none-600">&nbsp;Tools</span>
                  </div>
                  <div className="arrow down"></div>
                  <ul
                    className={`dropdown ${
                      trackingToolsVisible ? '' : 'd-none'
                    }`}
                  >
                    <div className="dropdown-arrow"></div>
                    <li>
                      <a
                        href={
                          context.user.is_authenticated
                            ? '/in/timeline'
                            : undefined
                        }
                        onClick={() => handleProfileItemClick()}
                      >
                        <FeatureIcons feature="timeline" />
                        <div className="tools_content">
                          <div>TIMELINE</div>
                          <p>
                            A personalised feed with updates about your
                            companies
                          </p>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a
                        href={`${
                          context.user.is_authenticated
                            ? '/in/portfolio'
                            : '/in/portfolio/sample'
                        }`}
                      >
                        <FeatureIcons feature="portfolio" />
                        <div className="tools_content">
                          <div>PORTFOLIO</div>
                          <p>
                            Keep an eye on your investments and keep track of
                            your exposure & risk
                          </p>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a
                        href={
                          context.user.is_authenticated
                            ? '/in/watchlist'
                            : undefined
                        }
                        onClick={() => handleProfileItemClick()}
                      >
                        <FeatureIcons feature="watchlist" />
                        <div className="tools_content">
                          <div>WATCHLIST</div>
                          <p>
                            Follow your favourite stocks and make more informed
                            trades by creating watchlists
                          </p>
                        </div>
                      </a>
                    </li>
                    <li className="last">
                      <a
                        href={
                          context.user.is_authenticated
                            ? '/in/alerts'
                            : undefined
                        }
                        onClick={() => handleProfileItemClick()}
                      >
                        <FeatureIcons feature="alerts" />
                        <div className="tools_content">
                          <div>ALERTS</div>
                          <p>
                            Add price/volume alerts and get notified when they
                            are hit
                          </p>
                        </div>
                      </a>
                    </li>
                  </ul>
                </li>
                <li
                  className={`d-none-430 position-relative tools ${
                    context.areTabsFixed || isSearchVisible ? 'd-none' : ''
                  }`}
                  onClick={() => onToolsClick('research')}
                >
                  <div>
                    Research<span className="d-none-600">&nbsp;Tools</span>
                  </div>
                  <div className="arrow down"></div>
                  <ul
                    className={`dropdown research ${
                      researchToolsVisible ? '' : 'd-none'
                    }`}
                  >
                    <div className="dropdown-arrow"></div>
                    <li>
                      <a href="/in/ideas-dashboard/">
                        <FeatureIcons feature="ideas-dashboard" />
                        <div className="tools_content">
                          <div>IDEAS DASHBOARD</div>
                          <p>Find ideas to invest in</p>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a href="/?r=n">
                        <FeatureIcons feature="company-sector-research" />
                        <div className="tools_content">
                          <div>COMPANY & SECTOR RESEARCH</div>
                          <p>
                            View in-depth fundamental & technical data on
                            sectors
                          </p>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a href="/filter/popular-queries">
                        <FeatureIcons feature="stock-screener" />
                        <div className="tools_content">
                          <div>STOCK SCREENER</div>
                          <p>
                            Discover new companies to invest in by filtering in
                            simple natural language
                          </p>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a href="/in/markets">
                        <FeatureIcons feature="markets" />
                        <div className="tools_content">
                          <div>MARKET MONITOR</div>
                          <p>
                            Monitor performance across sectors using niche
                            sector specific indices
                          </p>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a href="/in/macro">
                        <FeatureIcons feature="macro" />
                        <div className="tools_content">
                          <div>MACRO INDICATORS</div>
                          <p>
                            View macro-economic data sets which provides a
                            high-level view of the economy
                          </p>
                        </div>
                      </a>
                    </li>
                    <li className="last">
                      <a href="/in/raw-materials">
                        <FeatureIcons feature="raw-materials" />
                        <div className="tools_content">
                          <div>RAW MATERIALS</div>
                          <p>Track price movements of key raw materials</p>
                        </div>
                      </a>
                    </li>
                  </ul>
                </li>
                <li
                  className={`position-relative search-bar ${
                    context.areTabsFixed ? 'd-none' : ''
                  }`}
                >
                  <SearchBar isStatic={true} />
                </li>
                <li
                  className={`search-widget-cont ${
                    context.user.is_authenticated ? 'auth' : ''
                  } ${context.areTabsFixed ? 'd-block fixed-tabs' : ''} ${
                    isSearchVisible ? 'ml-0' : ''
                  }`}
                >
                  <SearchBar setIsSearchVisible={setIsSearchVisible} />
                </li>
                {!context.user.is_authenticated && !context.areTabsFixed && (
                  <a
                    href="/account/signin"
                    className={`signin-btn ${isSearchVisible ? 'd-none' : ''}`}
                  >
                    Sign In
                  </a>
                )}
                <li
                  className={`mx-0 initials_cont ${
                    context.user.is_authenticated ? '' : 'sample'
                  } ${context.areTabsFixed ? 'd-block fixed-tabs' : ''} ${
                    isSearchVisible ? 'd-none' : ''
                  }`}
                >
                  <div
                    className={`nav-user ${
                      !context.user.is_authenticated
                        ? 'sample'
                        : context.planDetails.name === 'free'
                        ? 'mr-4'
                        : ''
                    } ${isSearchVisible ? 'd-none' : ''}`}
                    onClick={handlePopoverVisibility}
                  >
                    {context.user.is_authenticated ? (
                      <>
                        <div className="initials auth" ref={popoverContainer}>
                          {getInitials()}
                        </div>
                      </>
                    ) : (
                      <div className="initials sample" ref={popoverContainer}>
                        <span className="bars-icon"></span>
                      </div>
                    )}
                    <Overlay
                      show={showPopover}
                      target={popoverTarget}
                      placement="bottom"
                      rootClose={true}
                      onHide={() => setShowPopover(false)}
                    >
                      {popover}
                    </Overlay>
                  </div>
                </li>
                {context.user.is_authenticated &&
                  context.planDetails.name === 'free' &&
                  !context.areTabsFixed && (
                    <a
                      href="/account/subscription"
                      className="signin-btn upgrade"
                    >
                      Upgrade now
                    </a>
                  )}
              </ul>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>

      <FeedbackForm show={fbModalVisible} setShow={setFbModalVisible} />
      {/* sign up for free/login req modal */}
      <LoginRequiredModal
        isVisible={isLoginModalVisible}
        setIsVisible={setIsLoginModalVisible}
      />
    </>
  );
}

export default Header;
